/** 是否对接后端 API（开发默认 true，构建可通过 VUE_APP_USE_API=false 切回 Mock） */
export const USE_API =
  process.env.VUE_APP_USE_API !== 'false' &&
  process.env.VUE_APP_USE_API !== '0'

export const API_BASE =
  process.env.VUE_APP_API_BASE || '/api'
